/*
* Created on Feb 04, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import { useRef, useState, useEffect, useCallback } from 'react';
import ModalComponent from "../common/ModalComonent/ModalComponent";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import {useTranslation} from "react-i18next";


const SettingsAvatarModal = ({isOpen, onClose, onSubmit, title}) => {
    const {t} = useTranslation();
    const uploadFile = useRef(null);
    const [avatarImage, setAvatarImage] = useState();
    const [crop, setCrop] = useState({
        unit: '%', // Can be 'px' or '%'
        width: 100,
        height: 100});
    const [completedCrop, setCompletedCrop] = useState(null);
    const imgRef = useRef(null);
    const [formData, setFormData] = useState(new FormData());
    const [showImageCrop, setShowImageCrop] = useState('hide');
    const [showUploading, setShowUploading] = useState(false);

    const onOpenFileUpload = () => {
        uploadFile.current.click();
    }

    const onFileChange = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const file = uploadFile.current.files[0];
        if (file) {
            setAvatarImage(URL.createObjectURL(file));
        }
        console.log(file);

        const _form = new FormData();
        _form.append('avatar_file', uploadFile.current.files[0]);
        setFormData(_form);
    }

    const check_upload_file = () => {
        return !!imgRef?.current;
    }

    const uploadAvatar = async () => {
        setShowUploading(true);
        await onSubmit(formData);
        setShowUploading(false);
    }

    useEffect(() => {
        if (!completedCrop) return;
        const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
        const scaleY = imgRef.current.naturalHeight / imgRef.current.height;
        const cords = {
            x: completedCrop.x * scaleX,
            y: completedCrop.y * scaleY,
            width: completedCrop.width * scaleX,
            height: completedCrop.height * scaleY
        }
        console.log(cords)
        const _form = new FormData();
        _form.append('avatar_file', uploadFile.current.files[0]);
        _form.append('origin_w', Math.floor(cords.width));
        _form.append('origin_h', Math.floor(cords.height));
        _form.append('x1', Math.floor(cords.x));
        _form.append('y1', Math.floor(cords.y));
        setFormData(_form);

    }, [completedCrop]);

    useEffect(()=>{
        if (avatarImage) {
            setShowImageCrop('');
        }
        else {
            setShowImageCrop('hide');
        }
    }, [avatarImage]);

    return (
        <ModalComponent title={title} isOpen={isOpen} onClose={onClose}
                        onSubmit={async () => await uploadAvatar()}
                        modalSize={'small'} okText={t('@Upload@')}
                        input={formData}
                        preSubmit={check_upload_file}
                        onError={()=>setShowUploading(false)}>
            <div className="dialog-content">
                {/* Uploading indicator */}
                {showUploading &&
                    <div className="dialog-loading-wrapper">
                        <div className="q-loading-indicator">
                            <div className="indicator-anime">
                                <div className="dash dash-1"></div>
                                <div className="dash dash-2"></div>
                                <div className="dash dash-3"></div>
                                <div className="dash dash-4"></div>
                            </div>
                            <div className="indicator-content">
                                <div className="indicator-label">
                                    <span className="text">{t('@Loading@')}...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div className="avatar-update">
                    <div className={`avatar-section ${showImageCrop}`}>
                        <ReactCrop crop={crop} onChange={c => setCrop(c)} onComplete={c => setCompletedCrop(c)} aspect={1}>
                            <img src={avatarImage} alt="" ref={imgRef}/>
                        </ReactCrop>
                    </div>
                    <div className="browse-file">
                        <button type="button" className="q-btn q-btn-default q-btn-round-corner" onClick={onOpenFileUpload}>{t('@Select from computer@')}</button>
                        <input type='file' ref={uploadFile} className='hide' onChange={(e)=>onFileChange(e)}/>
                        <div className="text-note fs13 !mt-16 text-align-center">{t('@Maximum upload file size: {{maxFileSize}} MB@', {maxFileSize: 5})}</div>
                    </div>
                </div>
            </div>
        </ModalComponent>
    );
};

export default SettingsAvatarModal;